import select from './SearchRoleSelect.vue'
const SearchRoleSelect = {
  install: function (Vue) {
    Vue.component('SearchRoleSelect', select)
  }
}
export default SearchRoleSelect
